import { AppBar, Box, Toolbar } from '@mui/material';
import TenantLogoImage from '../TenantLogoImage';
import AvatarMenu from './AvatarMenu';
import Links from './Links';

export default function NavBar({
    currentAuthenticatedUser,
    onSignOut,
    code,
    links = [],
    hideNav = false,
}) {

    return (
        <AppBar position="static" >
            <Toolbar disableGutters>
                <Box
                    padding='5px'
                    marginTop='4px'
                    alignItems='center' justifyContent='center'>
                    <TenantLogoImage
                        height="32"
                        code={code}
                        alt="logo"
                        fallbackSrc="/assets/Circle-FNI.png"
                    />
                </Box>

                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                    {!hideNav && currentAuthenticatedUser?.isValid && links?.length ?
                        <Links links={links}  /> : null }
                </Box>

                <Box sx={{ flexGrow: 0 }}>
                    {!hideNav && currentAuthenticatedUser?.isFNIAdmin ?
                        <AvatarMenu onLogout={onSignOut} currentAuthenticatedUser={currentAuthenticatedUser} /> : null
                    }
                </Box>

            </Toolbar>
        </AppBar>
    );
}
